import {
  call,
  put,
  takeEvery,
} from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import { showErrorNotification } from 'store/shared/actions';
import * as constants from './constants';
import * as actions from './actions';

function* createImage(action) {
  try {
    const data = new FormData();

    data.set('file', action.payload.data);

    const params = {
      headers: {},
      data,
      isFormData: true,
    };

    const result = yield call(request, API.IMAGES, 'POST', params);
    yield put(actions.createImageSuccess({ data: result.data }));
  } catch (e) {
    yield put(actions.createImageError(e));
    yield put(showErrorNotification({ message: 'Failed to upload data, please try later.' }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* createImageWatcher() {
  yield takeEvery(constants.CREATE_IMAGE, createImage);
}

function* createImageByUrl(action) {
  try {
    const params = {
      headers: {},
      data: { url: action.payload.url },
    };

    const result = yield call(request, API.IMAGES_URL, 'POST', params);
    yield put(actions.createImageByUrlSuccess({ data: { ...result.data, originalUrl: action.payload.url } }));
  } catch (e) {
    yield put(actions.createImageByUrlError(e));
    yield put(showErrorNotification({ message: 'Failed to upload data, please try later.' }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* createImageByUrlWatcher() {
  yield takeEvery(constants.CREATE_IMAGE_BY_URL, createImageByUrl);
}
